import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { IAppConfigMerchant } from '@modules/merchant/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { MERCHANT_SETTINGS_PERMISSIONS } from '@modules/merchant-settings/constants';

import type { IMerchantSettingsResponse } from '../types';
import {
  GET_MERCHANT_SETTINGS_QUERY_KEY,
  MERCHANT_SETTINGS_API_URL,
} from '../constants';

export default function useGetMerchantSettingsQuery(merchantId: Ref<number | undefined>): IContextQueryResult<
  IMerchantSettingsResponse,
  Error,
  IAppConfigMerchant
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IMerchantSettingsResponse, Error, IAppConfigMerchant>({
    queryKey: [GET_MERCHANT_SETTINGS_QUERY_KEY, merchantId],
    queryFn: ({ signal }) => fetchGet<IMerchantSettingsResponse>(MERCHANT_SETTINGS_API_URL, {
      signal,
      permission: MERCHANT_SETTINGS_PERMISSIONS.EDIT,
      urlParams: {
        id: merchantId.value,
      },
    }),
    select: (data) => (data.merchant),
    enabled: computed(() => !!merchantId.value),
  });
}
